module.exports = __webpack_public_path__ + "static/media/phone-square-alt.6a530ea1.svg";